"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _styles = require("@mui/material/styles");

var _excluded = ["onClick", "isSelected", "style", "element", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PREFIX = 'RectangularOption';
var classes = {
  optionStyles: "".concat(PREFIX, "-titleStyles"),
  selectedStyles: "".concat(PREFIX, "-selectedStyles")
};

function RectangularOption(_ref) {
  var _clsx;

  var onClick = _ref.onClick,
      isSelected = _ref.isSelected,
      style = _ref.style,
      element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded);

  var StyledRectangularOption = (0, _styles.styled)(element || _material.Button)(function (_ref2) {
    var _ref3;

    var theme = _ref2.theme;
    return _ref3 = {}, _defineProperty(_ref3, "&.".concat(classes.optionStyles), {
      background: theme.palette.rectangularOption.background.primary,
      color: theme.palette.rectangularOption.font.primary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.primary),
      textTransform: 'none',
      borderRadius: '4px'
    }), _defineProperty(_ref3, "&.".concat(classes.selectedStyles), {
      background: theme.palette.rectangularOption.background.secondary,
      color: theme.palette.rectangularOption.font.secondary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.secondary)
    }), _defineProperty(_ref3, '&:hover', {
      background: theme.palette.rectangularOption.background.secondary,
      color: theme.palette.rectangularOption.font.secondary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.secondary)
    }), _ref3;
  });
  return /*#__PURE__*/_react.default.createElement(StyledRectangularOption, _extends({
    className: (0, _clsx2.default)(classes.optionStyles, (_clsx = {}, _defineProperty(_clsx, classes.selectedStyles, isSelected), _defineProperty(_clsx, className, className), _clsx)),
    onClick: onClick,
    style: style
  }, other), children);
}

RectangularOption.propTypes = {
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  isSelected: _propTypes.default.bool,
  style: _propTypes.default.object
};
var _default = RectangularOption;
exports.default = _default;